// In Safari < 17, use container query cqw fallback
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
if (isSafari) {
  const version = navigator.userAgent.match(/Version\/([^ ]+)/)?.[1] ?? '100'
  if (version.localeCompare('17.0', 'en-US', { numeric: true }) < 0) {
    import('./cqw.js').then(({ initCqwFallback }) => {
      initCqwFallback()
    })
  }
}
